import PricingModelPopup from './PricingModelPopup';

export default PricingModelPopup;
